<template>
    <div v-if="profile">
      <div class="profile-block__name title-h4">{{ profile.NAME }} {{ profile.LAST_NAME }}</div>
      <div class="profile-block__contacts">
        <p>{{ profile.PERSONAL_MOBILE }}</p>
        <p>{{ profile.EMAIL }}</p>
        <p>{{ profile.PERSONAL_BIRTHDAY }}</p>
      </div>

      <profile-footer-menu></profile-footer-menu>

      <div class="profile-block__links">
        <p><a href="/personal/?logout=yes" class="">Выйти</a></p>
      </div>

      <div class="profile-block__bottom" v-if="!profile.PERSONAL_BIRTHDAY">
        <router-link :to="{'name': 'profile-edit'}">Заполните</router-link> пожалуйста дату рождения, что бы мы могли дарить вам подарки
      </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";
    import ProfileFooterMenu from "@/components/Personal/ProfileFooterMenu";

    export default {
        name: 'ProfileInfo',
        components: {
          ProfileFooterMenu,
        },
        computed: {
          ...mapState('StorePersonal', ['profile']),
        },
        watch: {

        },
        methods: {
          ...mapActions('StorePersonal', ['loadProfile']),
        },
        mounted() {
          this.loadProfile();
        }
    }
</script>